import React from 'react';
import { Box } from '@mui/material';
import MediumTypography from '../../components/formlib/MediumTypography';

export interface TimeOutLogCardData {
  name?: string;
  totalAccrualBenifit?: number | string | null;
  accruedYtd?: number | string | null;
  usedYtd?: number | string | null;
  pendingHours?: number | string | null;
  acceptedHours?: number | string | null;
  balanceAvailable?: number | string | null;
  remainderToAccrue?: number | string | null;
  
}

interface TimeOutLogsCardProps {
  data: TimeOutLogCardData;
}

export const formatTimeOffValue = (
  value: number | string | null | undefined,
): number | string => {
  if (value == null || value === '') return 0;
  return Number(value) === 0 ? 0 : value;
};

export const fieldLabels: {
  key: keyof TimeOutLogCardData;
  label: string;
}[] = [
  {
    key: 'totalAccrualBenifit',
    label: 'Total Accrual Benefit:',
  },
  {
    key: 'accruedYtd',
    label: 'Accrued YTD:',
  },
  {
    key: 'usedYtd',
    label: 'Used YTD:',
  },

  {
    key: 'balanceAvailable',
    label: 'Balance Available:',
  },
  {
    key: 'remainderToAccrue',
    label: 'Remainder to Accrue:',
  },
  {
    key: 'pendingHours',
    label: 'Pending:',
  },
  {
    key: 'acceptedHours',
    label: 'Accepted:',
  },
];

export const getFieldLabels = (name?: string) => {
  const isHolidayName = name === 'Holiday' || name === 'Holiday Time';
  return fieldLabels.map(({ key, label }) => {
    if (isHolidayName) {
      if (key === 'accruedYtd') return { key, label: 'Total Projected Benefit:' };
      if (key === 'balanceAvailable') return { key, label: 'Projected Balance:' };
    }
    return { key, label };
  });
};

const TimeOutLogsCard: React.FC<TimeOutLogsCardProps> = ({ data }) => {
  const rows = getFieldLabels(data.name).filter(
    ({ key }) =>
      data[key] !== undefined &&
      data[key] !== null &&
      data[key] !== '',
  );



  return (
  <Box
    sx={{
      width: '100%',
      height: '100%',
      minHeight: '130px',
      boxSizing: 'border-box',
      border: '1px solid #B8C5C4',
      borderRadius: '3px',
      backgroundColor: '#F8FAFA',
      padding: '12px 14px',
    }}
  >
    {/* Title */}
    <MediumTypography
      label={data.name}
      sxProps={{
        fontSize: '12px',
        lineHeight: '16px',
        fontWeight: 700,
        color: '#2A4241',
        marginBottom: '7px',
        whiteSpace: 'nowrap',
      }}
    />

    {/* Fields */}
    {rows.map(({ key, label }) => (
      <Box
        key={key}
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '16px',
          minHeight: '18px',
          marginBottom: '4px',
        }}
      >
        <MediumTypography
          label={label}
          sxProps={{
            fontSize: '10px',
            lineHeight: '15px',
            fontWeight: 700,
            color: '#455A59',
            whiteSpace: 'nowrap',
          }}
        />

        <MediumTypography
          label={`${formatTimeOffValue(data[key])} hrs`}
          sxProps={{
            fontSize: '10px',
            lineHeight: '15px',
            fontWeight: 700,
            color: '#00AFA5',
            whiteSpace: 'nowrap',
            textAlign: 'right',
          }}
        />
      </Box>
    ))}
  </Box>
  );
};

export default TimeOutLogsCard;
